var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dose-dependent_wrap"},[_c('DoseDependentContent'),_c('DoseDependentCTA')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }